/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import Background from "./Background";
import ConnectWallet from "./ConnectWallet";
import { useStateContext } from "../utils/web3";
import Profile from "./Profile";

const COLLECTIONS = {
  OG: 'nonconformistducks',
  HELL: 'nonconformisthellducks',
  SECOND: 'noncoducks2gen'
}

function Royalties() {
  const { isConnected, account, secondUsed } = useStateContext();
  const [filter, setFilter] = useState<number>(0);
  const [hellducks, setHellducks] = useState<any>([]);
  const [ogDucks, setOgDucks] = useState<any>([]);
  const [secondDucks, setSecondDucks] = useState<any>([]);
  const [loadingHell, setLoadingHell] = useState(true);
  const [loadingOG, setLoadingOG] = useState(true);
  const [loading2nd, setLoading2nd] = useState(true);
  const apiKey =  '07e8f6365ba14b46b3d1c5842d9d10a0';
  const options = {
    method: 'GET',
    headers: { Accept: 'application/json', 'X-API-KEY': apiKey },
  };

  const selectFilter = (traits:number) => {
    if (!loadingHell && !loadingOG) {
      setFilter(traits);
    }
  }
  useEffect(() => {
    if (account) {
      fetchDucks('nonconformistducks', account);
      fetchDucks('nonconformisthellducks', account);
      fetchDucks('noncoducks2gen', account);
    }
  }, [ account ]);

  const confirm2nd = async (ducks:any) => {
    const filteredDucks = [];
    for (let index = 0; index < ducks.length; index++) {
      const element = ducks[index];
      if (!await isSecondUsed(element)) {
        filteredDucks.push(element);
      }
    }
    setSecondDucks(filteredDucks)
    setLoading2nd(false)
  }

  const isSecondUsed = async (params:any) => {
    return await secondUsed(params.token_id);
  }

  const fetchDucks = async (collection:any, address:any)=> {
    let fetching = true;
    const ducks:any = [];
    let cursor:any = null;
    while(fetching) {
      const response = await fetch('https://api.opensea.io/api/v1/assets?owner=' + address + '&collection_slug='+ collection + '&limit=50' + (cursor ? ('&cursor=' + cursor) : ''), options);
      const data = await response.json();
      for (let index = 0; index < data.assets.length; index++) {
        ducks.push(data.assets[index]); 
      }
      if (data.next) {
        cursor = data.next;
      } else {
        fetching= false;
      }
    }
    switch (collection) {
      case COLLECTIONS.HELL:
        setHellducks(ducks);
        setLoadingHell(false)
        break;
      case COLLECTIONS.SECOND:
        confirm2nd(ducks)
        break;
      case COLLECTIONS.OG:
        setOgDucks(ducks)
        setLoadingOG(false)
        break;
    }
  }

  return (
    <>
      <div className="flex w-full h-5/6 z-10">
          {
            isConnected ? 
            (
              <div className="flex flex-col w-11/12 mx-auto relative h-full pb-10">
                <div className="flex flex-col items-center mb-10 w-full h-1/6">
                  <div className="uppercase font-bold txt-white text-7xl md:text-4xl w-4/5 text-center">
                    Filters
                  </div>
                  <div className="flex justify-around w-2/5 m-auto">
                    <button onClick={()=>{selectFilter(4)}} className={`flex ${ filter === 4 ? 'active-bg' : 'og-bg-opacity-black'} rounded-lg h-fit px-8 py-4`}>
                      <div className={`m-auto leading-normal uppercase ${ filter === 4 ? 'txt-black' : 'txt-white'} text-6xl md:text-3xl`}> 
                        {
                          (loadingOG && loadingHell) ? 
                          <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                          :
                          '4T'
                        }
                      </div>
                    </button>
                    <button onClick={()=>{selectFilter(5)}} className={`flex ${ filter === 5 ? 'active-bg' : 'og-bg-opacity-black'} rounded-lg h-fit px-8 py-4`}>
                      <div className={`m-auto leading-normal uppercase ${ filter === 5 ? 'txt-black' : 'txt-white'} text-6xl md:text-3xl`}> 
                        {
                          (loadingOG && loadingHell) ? 
                          <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                          :
                          '5T'
                        }
                      </div>
                    </button>
                    <button onClick={()=>{selectFilter(6)}} className={`flex ${ filter === 6 ? 'active-bg' : 'og-bg-opacity-black'} rounded-lg h-fit px-8 py-4`}>
                      <div className={`m-auto leading-normal uppercase ${ filter === 6 ? 'txt-black' : 'txt-white'} text-6xl md:text-3xl`}> 
                        {
                          (loadingOG && loadingHell) ? 
                          <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                          :
                          '6T'
                        }
                      </div>
                    </button>
                  </div>
                </div>
                <Profile
                  filter={filter}
                  hellducks={hellducks}
                  ogDucks={ogDucks}
                  secondDucks={secondDucks}
                  loadingHell={loadingHell}
                  loadingOG={loadingOG}
                  loading2nd={loading2nd}
                  setHellducks={setHellducks}
                  setSecondDucks={setSecondDucks}
                  setOgDucks={setOgDucks}></Profile>
              </div>
            )
            :
            (
              <ConnectWallet></ConnectWallet> 
            )
          }
      </div>
      <Background></Background>
    </>
  )
}

export default Royalties;